module.exports = __webpack_public_path__ + "img/45_26.2134a5ce.png";